import { prompt, type PromptDefinition } from './models';

export const CONSTRUCTION_MANAGER_PROMPTS = [
    prompt(
        'Plan change',
        'Which construction activities and constraints are documented for this building?',
        'Which buildings have construction constraints needing coordination first?'
    ),
    prompt(
        'Plan change',
        'What inspection hold points are recorded for construction in this building?',
        'Which buildings have construction hold points awaiting inspection evidence?'
    ),
    prompt(
        'Plan change',
        "Which defects or non-conformances remain open in this building's construction records?",
        'Compare open construction defects and non-conformances across my buildings.'
    ),
    prompt(
        'Plan change',
        'Find construction work packages for this building covering…',
        'Find construction work packages across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Plan change',
        'Which approved drawing revisions should be checked before work in this building?',
        'Which buildings have construction drawing revisions that need reconciliation?'
    ),
    prompt(
        'Manage risk',
        'What site safety controls are documented for construction at this building?',
        'Which buildings have gaps in documented construction safety controls?'
    ),
    prompt(
        'Plan change',
        'What trade interfaces or sequencing issues are recorded for this building?',
        'Which buildings have unresolved trade interfaces or sequencing issues?'
    ),
    prompt(
        'Plan change',
        'Find construction inspection records for this building relating to…',
        'Find construction inspection records across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Plan change',
        'Which materials installed in this building lack certification records?',
        'Which buildings have installed materials without required certification evidence?'
    ),
    prompt(
        'Plan change',
        "What evidence supports practical completion of this building's works?",
        'Which buildings have practical-completion claims with outstanding evidence gaps?'
    ),
    prompt(
        'Plan change',
        "Which as-built documents remain outstanding for this building's construction handover?",
        'Compare construction handover document gaps across my buildings.'
    ),
    prompt(
        'Plan change',
        "Trace construction quality evidence for this building's…",
        'Compare construction quality evidence across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
